import type { FC } from 'react';

import { HelpConnected } from '../../../help/HelpConnected';
import { HelpFooterConnected } from '../../../help/HelpFooterConnected';
import { NavPage } from '../page/NavPage';

export const NavPageHelpConnected: FC = () => {
  return (
    // TODO Pass footer data as props
    <NavPage footer={<HelpFooterConnected />}>
      <HelpConnected inNavDrawer />
    </NavPage>
  );
};
